/* eslint-disable no-unused-vars */
export enum EventName {
  // index
  click_get_started = 'click_get_started',
  click_add_account = 'click_add_account',
  select_platform = 'select_platform',
  input_account_handle = 'input_account_handle',
  //添加账号弹窗
  account_add_success = 'account_add_success',
  view_verification_step = 'confirm_account_addition',
  copy_verification_text = 'copy_verification_text',
  skip_verification = 'skip_verification',
  //onlyfans保护解决方案页面  /onlyfans-protection
  input_username = 'input_username',
  click_scan_now = 'click_scan_now',
  click_remove_now = 'click_remove_now',

  login = 'login',
  sign_up = 'sign_up',
  search = 'search',
  begin_checkout = 'begin_checkout',
  purchase = 'purchase',
  purchase_fail = 'purchase_fail',

  view_pricing = 'view_pricing',
  click_pricing_plan = 'click_pricing_plan',
  input_reverse_username = 'input_reverse_username',
  click_username_search = 'click_username_search',
  reverse_result_generated = 'reverse_result_generated',
  click_show_more_results = 'click_show_more_results',
  switch_reverse_search_tab = 'switch_reverse_search_tab',
  click_upload_picture = 'click_upload_picture',
  click_upgrade_auto_removal = 'click_upgrade_auto_removal',
  auto_removal_activated = 'auto_removal_activated',
  click_affiliate_invite_cta = 'click_affiliate_invite_cta',
  click_affiliate_invite_now = 'click_affiliate_invite_now',
  affiliate_share_success = 'affiliate_share_success',
  // header
  header_Home = 'header_Home',
  dmca_Home = 'dmca_Home',
  header_Plan = 'header_Plan',
  header_FAQ = 'header_FAQ',
  header_Analytics_Sample = 'header_Analytics_Sample',
  header_star_data = 'header_star_data',
  header_Blog = 'header_Blog',
  free_tools = 'free tools',
  header_SignIn = 'header_SignIn',
  header_Dashboard = 'header_Dashboard',
  header_Settings = 'header_Settings',
  header_Payment_History = 'header_Payment_History',
  header_Logout = 'header_Logout',
  header_tool = 'header_tool',
  header_service = 'header_service',
  header_onlyfans_protection = 'header_onlyfans_protection',
  header_remove_leaked_onlyfans_content = 'header_remove_leaked_onlyfans_content',
  header_remove_fake_account = 'header_remove_fake_account',
  header_shadowban_test = 'header_shadowban_test',
  header_cam_model_protection = 'header_cam_model_protection',
  header_onlyfans_competitors = 'header_onlyfans_competitors',
  header_affiliate = 'header_affiliate',
  header_dmca_takedown = 'header_dmca_takedown',
  header_photo_protection = 'header_photo_protection',
  header_contact = 'header_contact',
  header_find_and_remove_revenge_porn = 'header_find_and_remove_revenge_porn',
  header_ai_image_abuse_detection = 'header_ai_image_abuse_detection',
  // login
  // login_Google = 'login_Google',
  // login_Sign_In = 'login_Sign_In',
  // login_Sign_Up = 'login_Sign_Up',
  login_Forgot_Password = 'login_Forgot_Password',

  // home
  home_See_Analytics_Sample = 'home_See_Analytics_Sample',
  home_ADD_ACCOUNT = 'home_ADD_ACCOUNT',
  // dashboard
  dashboard_ADD_ACCOUNT = 'dashboard_ADD_ACCOUNT',
  dashboard_See_Analytics = 'dashboard_See_Analytics',
  dashboard_Buy_past_reports = 'dashboard_Buy_past_reports',
  dashboard_Buy_past_reports_btn = 'dashboard_Buy_past_reports_btn',
  dashboard_Delete = 'dashboard_Delete',
  dashboard_Check = 'dashboard_Check',
  dashboard_Add_new_account = 'dashboard_Add_new_account',
  // settings
  settings_Password_Change = 'settings_Password_Change',
  settings_Plan_Stop = 'settings_Plan_Stop',
  settings_Plan_Subscription = 'settings_Plan_Subscription',
  settings_Logout = 'settings_Logout',
  settings_Delete_Account = 'settings_Delete_Account',
  // 访问用户数：
  Login_View = 'login_View',
  Blog_Detail_Bottom_AddAccount_Btn = 'Blog_Detail_Bottom_AddAccount_Btn',

  // 注册成功用户数：
  user_register_Success = 'user_register_Success',
  // 注册失败用户数：
  user_register_Fail = 'user_register_Fail',
  // 登录用户数：
  user_Login_Success = 'user_Login_Success',
  // 登录用户样本分析访问用户数：
  Sample_View = 'sample_View',
  // 样本详情页访问用户数（3个样本页面排重后的合集用户）：
  Sample_See_Analytics = 'sample_See_Analytics',
  // 点击"Ckeck"用户数（只要尝试点击ADD ACCOUNT，一定添加成功）：
  // dashboard_Check = 'dashboard_Check',
  // "ADD ACCOUNT"成功添加用户数：
  Add_Account_Request_Success = 'add_Account_Request_Success',
  // Plan页面访问用户数：
  Plan_View = 'plan_View',
  // Plan页面点击"Subscribe"用户数：
  Plan_Subscribe_Request_Before = 'plan_Subscribe_Request_Before',
  // "Subscribe"成功用户数：
  Plan_Subscribe_Request_Success = 'Plan_Subscribe_Request_After',
  // "Subscribe"失败用户数：
  Plan_Subscribe_Request_Fail = 'plan_Subscribe_Request_Fail',
  Buy_Past_Report_Request_Success = 'buy_Past_Report_Request_Success',
  // "Buy past report"失败用户数：
  Buy_Past_Report_Request_Fail = 'buy_Past_Report_Request_Fail',
  Article_Bottom_Banner_Close_Icon = 'Article_Bottom_Banner_Close_Icon',
  Article_Bottom_Banner_Click = 'Article_Bottom_Banner_Click',
  User_AddModal_Ok = 'User_AddModal_Ok',
  User_addModal_Verify = 'User_addModal_Verify',
  User_addModal_Copy = 'User_addModal_Copy',
  // report
  Report_detail_Unlock = 'Report_detail_Unlock',
  Report_detail_Follow_us = 'Report_detail_Follow_us',
  Report_detail_Compare_search = 'Report_detail_Compare_search',
  Report_detail_dashboar_Left_Unlock = 'Report_detail_dashboar_Left_Unlock',
  Report_detail_dashboar_See_more_Unlock = 'Report_detail_dashboar_See_more_Unlock',
  // 反向图片搜索
  click_upload_image = 'click_upload_image',
  complete_upload_image = 'complete_upload_image',
  start_reverse_image_search = 'start_reverse_image_search',
  complete_upload_face_image = 'complete_upload_face_image',
  click_face_search_now = 'click_face_search_now',
  trigger_face_paywall = 'trigger_face_paywall',
  trigger_reverse_image_paywall = 'trigger_reverse_image_paywall',
  click_face_paywall_unlock = 'click_face_paywall_unlock',
  click_reverse_image_paywall_unlock = 'click_reverse_image_paywall_unlock',
  login_shown = 'login_shown',
  signup_shown = 'signup_shown',
}
export enum EventNameSource {
  home = 'home',
  onlyfansProtection = 'onlyfans-protection',
  camModelProtection = 'cam-model-protection',
  removeLeakedOnlyfansContent = 'remove-leaked-onlyfans-content',
  dashboard = 'dashboard',
  blogFeature = 'blog_feature',
  contentMonitoring = 'content-monitoring',
  reverseUsernameSearch = 'reverse-username-search',
  reversePhotoSearch = 'reverse-photo-search',
  reverseFaceSearch = 'reverse-face-search',
  compare = 'compare',
  protectedAccounts = 'protected-accounts',
}
